/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccPendingPatient
 */
export interface PccPendingPatient {
    /**
     * 
     */
    facId?: string;
    /**
     * 
     */
    patientId?: string;
    /**
     * 
     */
    status?: string;
}

/**
 * Check if a given object implements the PccPendingPatient interface.
 */
export function instanceOfPccPendingPatient(value: object): value is PccPendingPatient {
    return true;
}

export function PccPendingPatientFromJSON(json: any): PccPendingPatient {
    return PccPendingPatientFromJSONTyped(json, false);
}

export function PccPendingPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPendingPatient {
    if (json == null) {
        return json;
    }
    return {
        
        'facId': json['facId'] == null ? undefined : json['facId'],
        'patientId': json['patientId'] == null ? undefined : json['patientId'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function PccPendingPatientToJSON(json: any): PccPendingPatient {
    return PccPendingPatientToJSONTyped(json, false);
}

export function PccPendingPatientToJSONTyped(value?: PccPendingPatient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facId': value['facId'],
        'patientId': value['patientId'],
        'status': value['status'],
    };
}

